import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "forturn"
  }, [_c('div', {
    staticClass: "forturn-main"
  }, [_c('div', {
    staticClass: "forturn-bg",
    style: {
      background: `url(${require('@images/tapcoin/task-detail-bg.jpg')}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "forturn__title"
  }, [_vm._v("Fortune Box")]), _c('div', {
    staticClass: "forturn__sub"
  }, [_vm._v("Collect all required NFTS to get")]), _c('div', {
    staticClass: "forturn-synthesis"
  }, [_c('div', {
    staticClass: "forturn-synthesis-main"
  }, [_vm.forturnNftList ? _c('div', {
    staticClass: "forturn-synthesis-gcard",
    class: !_vm.isGcardShow && 'disable',
    style: {
      transform: 'scale(' + _vm.gcardScale + ')'
    }
  }, [_c('div', {
    staticClass: "forturn-synthesis-gcard-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/fortune/fortune-card.png'),
      "alt": ""
    }
  })])]) : _vm._e(), _c('div', {
    ref: `items`,
    staticClass: "forturn-synthesis-item xys",
    on: {
      "click": () => _vm.$router.push('/nfts')
    }
  }, [_vm._m(0)]), _c('div', {
    ref: "circleContainer",
    staticClass: "forturn-synthesis-list"
  }, [_vm.isForturnNftListLoading ? _vm._l(_vm.forturnNftList, function (item, index) {
    return _c('div', {
      staticClass: "forturn-synthesis-item",
      style: _vm.getCirclePositionStyle(index),
      on: {
        "click": () => _vm.$router.push('/nfts')
      }
    }, [_c('div', {
      staticClass: "forturn-synthesis-item-main",
      class: item.attr_Bg.replace(/\s*/g, '')
    }, [item.nft_count > 0 ? _c('div', {
      staticClass: "forturn-synthesis-item-card"
    }, [_c('img', {
      attrs: {
        "src": item.image_url,
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "forturn-synthesis-item-empty"
    })]), item.nft_count > 0 ? _c('div', {
      staticClass: "forturn-synthesis-item__tag"
    }, [_vm._v("x" + _vm._s(_vm._f("fmt_pre")(item.nft_count)))]) : _vm._e()]);
  }) : _vm._e()], 2)])]), _c('div', {
    staticClass: "forturn-btns"
  }, [!_vm.isBtnTryAgainShow ? _c('div', {
    staticClass: "btn-get",
    on: {
      "click": _vm.onCompose
    }
  }, [!_vm.isBtnGetLoading ? [_vm._v("Get")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2) : _c('div', {
    staticClass: "btn-get",
    on: {
      "click": _vm.onTryAgain
    }
  }, [!_vm.isBtnTryAgainLoading ? [_vm._v("Try Again")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)]), _c('div', {
    staticClass: "forturn-intro"
  }, [_vm._m(1), _c('div', {
    staticClass: "forturn-intro-main"
  }, [_c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" 1 Fortune Box = 1 reward")]), _c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" Chance to obtain rarer NFTs")]), _c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" Gain valuable digital assets")]), _c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" Access to revenue airdrop pools")]), _c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" MetaCats NFTs retain their attributes after the Fortune Box is activated.")])])]), _c('div', {
    staticClass: "forturn-cards"
  }, [_c('div', {
    staticClass: "forturn-cards__title"
  }, [_vm._v("Fortune Box")]), _c('div', {
    staticClass: "forturn-list"
  }, _vm._l(_vm.forturnList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "forturn-item",
      on: {
        "click": function ($event) {
          return _vm.onShowForturnDetail(item);
        }
      }
    }, [_c('div', {
      staticClass: "forturn-item-base"
    }, [_c('div', {
      staticClass: "forturn-item__icon"
    }, [_c('img', {
      attrs: {
        "src": require('@images/tapcoin/new/fortune/fortune-card.png'),
        "alt": ""
      }
    })])])]);
  }), 0)])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popForturnDetailShow,
      "width": "90%"
    },
    on: {
      "update:show": function ($event) {
        _vm.popForturnDetailShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popForturnDetail"
  }, [_c('div', {
    staticClass: "popForturnDetail-main"
  }, [_c('div', {
    staticClass: "popForturnDetail__title"
  }, [_vm._v("Forturn box")]), _c('div', {
    staticClass: "popForturnDetail__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/fortune/fortune-card.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "popForturnDetail-btns"
  }, [_c('div', {
    staticClass: "btn-open"
  }, [_vm._v("OPEN")])]), _c('div', {
    staticClass: "popForturnDetail-intro"
  }, [_c('div', {
    staticClass: "popForturnDetail-intro__title"
  }, [_vm._v(" Fortune Box Benefits "), _c('p', [_vm._v("Hold Fortune Box for a chance to unlock exclusive rewards")])]), _c('div', {
    staticClass: "popForturnDetail-intro-main"
  }, [_c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" 1 Fortune Box = 1 reward")]), _c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" Chance to obtain rarer NFTs")]), _c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" Gain valuable digital assets")]), _c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" Access to revenue airdrop pools")]), _c('i', [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok2"
    }
  })], 1), _vm._v(" MetaCats NFTs retain their attributes after the Fortune Box is activated.")])])]), _c('div', {
    staticClass: "popForturnDetail-lists"
  }, [_c('div', {
    staticClass: "popForturnDetail-list"
  }, _vm._l(_vm.forturnDetailNftList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "popForturnDetail-item",
      on: {
        "click": function ($event) {
          return _vm.onNftDetail(item);
        }
      }
    }, [_c('div', {
      staticClass: "popForturnDetail-item__img"
    }, [item?.image_url ? _c('img', {
      attrs: {
        "src": item.image_url,
        "alt": ""
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "popForturnDetail-item__label"
    }, [_vm._v(_vm._s(item.name))])]);
  }), 0)])])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popNFTDeficiencyShow,
      "width": "80%"
    },
    on: {
      "update:show": function ($event) {
        _vm.popNFTDeficiencyShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popNFTDeficiency"
  }, [_c('div', {
    staticClass: "popNFTDeficiency__title"
  }, [_vm._v("Missing NFT")]), _c('div', {
    staticClass: "popNFTDeficiency-btns",
    on: {
      "click": () => _vm.$router.push('/nfts')
    }
  }, [_vm._v("Get NFT")])])]), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "forturn-synthesis-item-main"
  }, [_c('div', {
    staticClass: "forturn-synthesis-item-empty"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "forturn-intro__title"
  }, [_vm._v(" Fortune Box Benefits "), _c('p', [_vm._v("Hold Fortune Box for a chance to unlock exclusive rewards")])]);
}];
export { render, staticRenderFns };